import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as mmeUtils from '../../../util/MMEUtils';

class MMEColumnHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      header: props.header,
      editEnabled: false,
    };
  }

  onMMEGridViewSort = (key, columnIndex) => {
    let sortOrder = mmeUtils.SORT_DIRECTION.DESC;
    if (
      this.props.sortColumnIndex === columnIndex &&
      this.props.sortKey === key
    ) {
      switch (this.props.sortOrder) {
        case mmeUtils.SORT_DIRECTION.DESC:
          sortOrder = mmeUtils.SORT_DIRECTION.ASC;
          break;
        case mmeUtils.SORT_DIRECTION.ASC:
          sortOrder = mmeUtils.SORT_DIRECTION.NONE;
          break;
        default:
          sortOrder = mmeUtils.SORT_DIRECTION.DESC;
      }
    }
    this.props.onSort(sortOrder, key, columnIndex);
  };

  getClassName = count => {
    switch (count) {
      case 1: return { width: '100%' };
      case 2: return { width: '50%' };
      case 3: return { width: '33.3%' };
      case 4: return { width: '25%' };
      case 5: return { width: '20%' };
      default: return { width: '0%' };
    }
  }

  render() {
    const {
      metricsList, metricsCount, sortOrder, sortKey, columnIndex,
      sortColumnIndex, rowValues, reportType,
    } = this.props;
    const { header } = this.state;
    return (
      <div className={header.isSelected ? 'c-table--col--selected' : 'c-table--col'}>
        <div className="title-container">
          {!this.state.editEnabled && <div>
            <div
              className="title-btn"
              title={`${(header.label.toUpperCase())} ${
                header.isColumnLabelUpdated ? String.fromCharCode(185) : ''
              }`}
            >{header.label}<sup>{header.isColumnLabelUpdated ? '1' : ''}</sup></div>
            <div className="mme-col-header-color" style={mmeUtils.getColumnRowColor(header.colorVal)} />
          </div>}
        </div>
        {header.label !== '' && <div className="cell mme-first-cell">
          {metricsList && metricsList.map(item => (
          <div key={item.label} className="cell--item" title={item.label} style={this.getClassName(metricsCount)}>
            <button
              type="button"
              id={`${item.key}-header${columnIndex}`}
              onClick={() => this.onMMEGridViewSort(item.key, columnIndex)}
              className="mme-column-text"
            >{item.text}
              {sortKey === item.key && sortOrder === 'desc' && sortColumnIndex === columnIndex &&
                <i data-test="desc">▼</i>}
              {sortKey === item.key && sortOrder === 'asc' && sortColumnIndex === columnIndex &&
                <i data-test="asc">▲</i>}
            </button>
          </div>))}
        </div>}
        {header.label !== '' && <div className="cell mme-all-rows-right-cell">
          {reportType === 'SR' && <div className="all-row-right-cell" title={`${rowValues.p}%`}>{rowValues.p}%</div>}
          {reportType === 'DR' && <div className="all-row-right-cell" title={rowValues.s}>{rowValues.s}</div>}
          <div className="all-row-right-cell" title={rowValues.i}>{rowValues.i}</div>
          <div className="all-row-right-cell" title={rowValues.r}>{rowValues.r}</div>
        </div>}
      </div>
    );
  }
}

MMEColumnHeader.propTypes = {
  metricsList: PropTypes.arrayOf(PropTypes.shape({})),
  metricsCount: PropTypes.number,
  columnIndex: PropTypes.number,
  sortColumnIndex: PropTypes.number,
  sortOrder: PropTypes.string,
  sortKey: PropTypes.string,
  onSort: PropTypes.func,
  header: PropTypes.shape({}),
  reportType: PropTypes.string,
  rowValues: PropTypes.shape({
    p: PropTypes.number,
    s: PropTypes.number,
    i: PropTypes.number,
    r: PropTypes.number,
  }),
};

export default MMEColumnHeader;
